import * as React from 'react';
import styles from './index.less';
import { Pagination, Popover, Space, Switch } from 'antd';
import Policies from './Policies';
import Viewports from './Viewports';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { CollectionExhibitInfoPageModelState, ConnectState } from '@/models/connect';
import {
  ChangeAction,
  FetchInfoAction,
  OnMountPageAction,
  UpdateBaseInfoAction,
  OnSave_Side_ExhibitIntroduction_Action,
  Fetch_CollectionItems_Action,
  OnSync_Options_Action,
} from '@/models/collectionExhibitInfoPage';
import FTooltip from '@/components/FTooltip';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FComponentsLib from '@freelog/components-lib';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import { onlineExhibit } from '@/utils/nodeTools';
import { fOnOffFeedback } from '@/components/fOnOffFeedback';
import FCoverImage from '@/components/FCoverImage';
import fMessage from '@/components/fMessage';
import FUploadCover from '@/components/FUploadCover';
import FResourceCard from '@/components/FResourceCard';
import FLoadingTip from '@/components/FLoadingTip';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import useUrlState from '@/hooks/useUrlState';
import FNoDataTip from '@/components/FNoDataTip';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import ResourceLabelsCard from '@/components/FResourceLabelsCard';
import fEditLabelsDrawer from '@/components/fEditLabelsDrawer';
import IntroductionCard from '@/components/FIntroductionCard';
import fEditIntroductionDrawer from '@/components/fEditIntroductionDrawer';
import FIcons from '@/components/FIcons';
import FCollectionItems2 from '@/components/FCollectionItems2';
import FGlobalLoading from '@/components/FGlobalLoading';
import FAttrsAndConfigs, { IAttrsAndConfigsItem } from '@/components/FAttrsAndConfigs';
import fResourcePropertyEditor3 from '@/components/fResourcePropertyEditor3';
import FCoverImageEditor from '@/components/FCoverImageEditor';
import { ExhibitTitleInput } from '@/pages/node/exhibit/formal/$id';
import FInput_Search from '@/components/FInput_Search';
import { useParams } from 'react-router-dom';

interface PresentableProps {
  dispatch: Dispatch;
  collectionExhibitInfoPage: CollectionExhibitInfoPageModelState;
}

function Presentable({ dispatch, collectionExhibitInfoPage }: PresentableProps) {
  const params = useParams<{ id: string }>();
  const refPromise = React.useRef<Promise<void> | null>(null);

  const ref_ItemsTitle = React.useRef<any>(null);
  const [urlState] = useUrlState<{ openAuthDrawer?: boolean }>();

  const [$authorizationUpdate, set$authorizationUpdate, get$authorizationUpdate] =
    FUtil.Hook.useGetState<number>(0);

  const [$globalLoading, set$globalLoading, get$globalLoading] =
    FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(() => {
    dispatch<OnMountPageAction>({
      type: 'collectionExhibitInfoPage/onMountPage',
      payload: {
        exhibitID: params.id!,
      },
    });
  });

  const { run: keywordsRun } = AHooks.useDebounceFn(
    () => {
      dispatch<Fetch_CollectionItems_Action>({
        type: 'collectionExhibitInfoPage/fetch_CollectionItems',
      });
    },
    {
      wait: 300,
    },
  );

  async function activateTheme() {
    const res1: boolean = await fPromiseModalConfirm({
      title: '提示',
      // icon: <div />,
      description: FI18n.i18nNext.t('msg_change_theme_confirm', {
        ThemeName: collectionExhibitInfoPage.exhibit_Name,
      }),
      okText: FI18n.i18nNext.t('btn_activate_theme'),
      cancelText: FI18n.i18nNext.t('keep_current_theme'),
    });

    if (!res1) {
      return;
    }

    await onlineExhibit({ exhibit_ID: collectionExhibitInfoPage.exhibit_ID });

    fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
      value: false,
      effectiveImmediately: true,
      onlyNullish: false,
    });

    dispatch<FetchInfoAction>({
      type: 'collectionExhibitInfoPage/fetchInfo',
    });
  }

  if (collectionExhibitInfoPage.pageLoading) {
    return <FLoadingTip height={'calc(100vh - 70px)'} />;
  }

  return (
    <div className={styles.Presentable}>
      <div className={styles.content}>
        <div style={{ height: 40 }} />
        <Space size={5}>
          <FComponentsLib.FTextBtn
            onClick={() => {
              window.open(
                FUtil.LinkTo.nodeManagement({
                  nodeID: collectionExhibitInfoPage.exhibit_BelongNode_ID,
                }),
              );
            }}
            style={{ fontWeight: 600 }}
            type='default'
          >
            <FComponentsLib.FContentText
              type={'negative'}
              // text={collectionExhibitInfoPage.exhibit_BelongNode_Name}
              text={
                collectionExhibitInfoPage.exhibit_BelongNode_Title ||
                collectionExhibitInfoPage.exhibit_BelongNode_Name
              }
              style={{ fontWeight: 600, maxWidth: 200 }}
              singleRow
            />
          </FComponentsLib.FTextBtn>
          <FComponentsLib.FContentText type={'negative'} text={'>'} style={{ fontWeight: 600 }} />
          <FComponentsLib.FContentText
            type={'highlight'}
            // text={collectionExhibitInfoPage.exhibit_Name}
            text={collectionExhibitInfoPage.exhibit_Title || collectionExhibitInfoPage.exhibit_Name}
            style={{
              maxWidth: 600,
            }}
            singleRow
          />
        </Space>
        <div style={{ height: 40 }} />
        <div className={styles.onlineSwitch}>
          {!collectionExhibitInfoPage.exhibit_IsAuth && (
            <Space size={5}>
              <FIcons.FWarning style={{ fontSize: 16 }} />
              <FComponentsLib.FContentText type={'additional2'} style={{ color: '#222' }}>
                {collectionExhibitInfoPage.exhibit_AuthErrorText}
              </FComponentsLib.FContentText>
            </Space>
          )}

          {collectionExhibitInfoPage.exhibit_IsAuth && (
            <>
              {!collectionExhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题') && (
                <>
                  <FComponentsLib.FContentText
                    text={
                      collectionExhibitInfoPage.exhibit_Online
                        ? // ? '展品已上架'
                          FI18n.i18nNext.t('edit_exhibit_status_availableforauth')
                        : // : '展品未上架'}
                          FI18n.i18nNext.t('edit_exhibit_status_pendingauth')
                    }
                    type={'normal'}
                    style={{ fontWeight: 600 }}
                  />
                </>
              )}
            </>
          )}

          <FHotspotTooltip
            id={'exhibitDetailPage.onlineSwitch'}
            style={{ left: -42, top: -4 }}
            text={FI18n.i18nNext.tAuto('hotpots_exhibit_toggle_exhibit')}
          >
            <Space size={20}>
              {!collectionExhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题') && (
                <>
                  <FComponentsLib.FContentText
                    type={'highlight'}
                    text={FI18n.i18nNext.t('switch_set_exhibit_avaliable')}
                  />
                  <Switch
                    disabled={
                      !collectionExhibitInfoPage.exhibit_IsAuth &&
                      !collectionExhibitInfoPage.exhibit_Online
                    }
                    checked={collectionExhibitInfoPage.exhibit_Online}
                    className={styles.CustomSwitch}
                    onChange={async (checked) => {
                      if (checked) {
                        await onlineExhibit({
                          exhibit_ID: collectionExhibitInfoPage.exhibit_ID,
                          async onStartOnline() {
                            set$globalLoading(true);
                          },
                          async onEndOnline() {
                            set$globalLoading(false);
                            await refPromise.current;
                          },
                        });
                      } else {
                        const confirm: boolean = await fPromiseModalConfirm({
                          // title: '下架展品',
                          // description: '下架后，其它用户将无法签约该展品，确认要下架吗？',
                          title: '提示',
                          description: FI18n.i18nNext.t('confirm_msg_remove_exhibits_from_auth'),
                          okText: FI18n.i18nNext.t('btn_remove_exhibits_from_auth'),
                          promptKey_localStorage: 'offlineExhibit',
                        });

                        if (confirm) {
                          const params2: Parameters<
                            typeof FServiceAPI.Exhibit.presentablesOnlineStatus
                          >[0] = {
                            presentableId: collectionExhibitInfoPage.exhibit_ID,
                            onlineStatus: 0,
                          };
                          set$globalLoading(true);
                          await FServiceAPI.Exhibit.presentablesOnlineStatus(params2);
                          set$globalLoading(false);
                          await refPromise.current;

                          fOnOffFeedback({
                            state: 'off',
                            message: FI18n.i18nNext.t('remove_resource_from_auth_msg_done'),
                          });
                        }
                      }
                      fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
                        value: false,
                        effectiveImmediately: true,
                        onlyNullish: false,
                      });
                      await dispatch<FetchInfoAction>({
                        type: 'collectionExhibitInfoPage/fetchInfo',
                      });
                    }}
                  />
                </>
              )}
            </Space>
          </FHotspotTooltip>
        </div>

        <div style={{ height: 5 }} />
        <div className={styles.exhibitInfo}>
          <FCoverImageEditor
            src={collectionExhibitInfoPage.exhibit_Cover || ''}
            width={260}
            onChange={(url) => {
              dispatch<UpdateBaseInfoAction>({
                type: 'collectionExhibitInfoPage/updateBaseInfo',
                payload: {
                  exhibit_Cover: url,
                },
              });
            }}
          />

          <div className={styles.info}>
            <div>
              <ExhibitTitleInput
                value={collectionExhibitInfoPage.side_ExhibitTitle}
                onOK={(value) => {
                  dispatch<UpdateBaseInfoAction>({
                    type: 'collectionExhibitInfoPage/updateBaseInfo',
                    payload: {
                      side_ExhibitTitle: value,
                    },
                  });
                }}
              />
              <div style={{ height: 5 }} />
              {collectionExhibitInfoPage.exhibit_ResourceInfo && (
                <>
                  <Space size={4}>
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      // text={'合集'}
                      text={collectionExhibitInfoPage.exhibit_ResourceInfo.type.join('/')}
                      style={{ color: '#999' }}
                    />

                    <FComponentsLib.FContentText
                      type={'additional2'}
                      text={'|'}
                      style={{ color: '#999' }}
                    />

                    <FComponentsLib.FContentText
                      type={'additional2'}
                      // text={'合集'}
                      text={FI18n.i18nNext.t('edit_exhibit_collection')}
                      style={{ color: '#999' }}
                    />
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      text={'|'}
                      style={{ color: '#999' }}
                    />

                    <FComponentsLib.FContentText
                      type={'additional2'}
                      text={
                        collectionExhibitInfoPage.exhibit_ResourceInfo.collection?.status ===
                        'finish'
                          ? // '已完结'
                            FI18n.i18nNext.t('cqr_itemmgmt_updatedstates_completed')
                          : // : '连载中'
                            FI18n.i18nNext.t('cqr_itemmgmt_updatestates_ongoing')
                      }
                      style={{
                        color:
                          collectionExhibitInfoPage.exhibit_ResourceInfo.collection?.status ===
                          'finish'
                            ? '#E9A923'
                            : '#42C28C',
                      }}
                    />
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      text={'|'}
                      style={{ color: '#999' }}
                    />

                    <FComponentsLib.FContentText
                      type={'additional2'}
                      // text={`展品标识：${collectionExhibitInfoPage.exhibit_BelongNode_Name}/${collectionExhibitInfoPage.exhibit_Name}`}
                      text={`${FI18n.i18nNext.tAuto('edit_exhibit_exhibitauthid')}${
                        collectionExhibitInfoPage.exhibit_BelongNode_Name
                      }/${collectionExhibitInfoPage.exhibit_Name}`}
                      style={{ color: '#999', maxWidth: 200 }}
                      singleRow
                    />
                  </Space>
                  <div style={{ height: 5 }} />
                  <Space size={4}>
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      // text={'来自于'}
                      text={FI18n.i18nNext.t('edit_exhibit_relative_article')}
                      style={{ color: '#999' }}
                    />
                    <Popover
                      // open={true}
                      content={
                        <FResourceCard
                          key={collectionExhibitInfoPage.exhibit_ResourceInfo.id}
                          resource={collectionExhibitInfoPage.exhibit_ResourceInfo}
                          // className={styles.FResourceCard}
                          onClick={() => {
                            window.open(
                              FUtil.LinkTo.collectionDetails({
                                collectionID:
                                  collectionExhibitInfoPage.exhibit_ResourceInfo?.id || '',
                              }),
                            );
                          }}
                        />
                      }
                      title={null}
                      placement={'bottom'}
                      overlayClassName={styles.resourceCardPopover}
                    >
                      <div style={{ width: 'fit-content' }}>
                        <FComponentsLib.FTextBtn
                          type='default'
                          style={{ color: '#999' }}
                          onClick={() => {
                            window.open(
                              FUtil.LinkTo.collectionDetails({
                                collectionID:
                                  collectionExhibitInfoPage.exhibit_ResourceInfo?.id || '',
                              }),
                            );
                          }}
                        >
                          <FComponentsLib.FContentText
                            type={'additional2'}
                            style={{
                              color: 'inherit',
                              textDecoration: 'underline',
                              maxWidth: 570,
                            }}
                            singleRow
                            text={collectionExhibitInfoPage.exhibit_ResourceInfo?.name || ''}
                          />
                        </FComponentsLib.FTextBtn>
                      </div>
                    </Popover>
                  </Space>
                </>
              )}
            </div>
            <div style={{ height: 20 }} />
            <ResourceLabelsCard
              labels={collectionExhibitInfoPage.side_ExhibitTags}
              onClick={async () => {
                const result: null | string[] = await fEditLabelsDrawer({
                  labels: collectionExhibitInfoPage.side_ExhibitTags,
                });
                if (result === null) {
                  return;
                }

                dispatch<UpdateBaseInfoAction>({
                  type: 'collectionExhibitInfoPage/updateBaseInfo',
                  payload: {
                    side_ExhibitTags: result,
                  },
                });
              }}
            />
            <div style={{ height: 10 }} />
            <IntroductionCard
              text={collectionExhibitInfoPage.side_ExhibitIntroduction}
              onClick={async () => {
                const result: null | string = await fEditIntroductionDrawer({
                  text: collectionExhibitInfoPage.side_ExhibitIntroduction,
                });
                if (result === null) {
                  return;
                }

                dispatch<OnSave_Side_ExhibitIntroduction_Action>({
                  type: 'collectionExhibitInfoPage/onSave_Side_ExhibitIntroduction',
                  payload: {
                    value: result,
                  },
                });
              }}
            />
          </div>
        </div>
        <div style={{ height: 5 }} />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <FComponentsLib.FTextBtn
            style={{ fontSize: 12 }}
            onClick={() => {
              dispatch<ChangeAction>({
                type: 'collectionExhibitInfoPage/change',
                payload: {
                  side_SettingUnfold: !collectionExhibitInfoPage.side_SettingUnfold,
                },
              });
            }}
          >
            {collectionExhibitInfoPage.side_SettingUnfold
              ? FI18n.i18nNext.tAuto('brr_resourcelisting_item_btn_showlesssetting')
              : FI18n.i18nNext.tAuto('edit_exhibit_moresetting_btn')}
          </FComponentsLib.FTextBtn>
          <FComponentsLib.FContentText
            text={'展示信息、自定义信息等'}
            // text={FI18n.i18nNext.tAuto('edit_exhibit_moresetting_info')}
            type={'negative'}
            style={{ fontSize: 12 }}
          />
        </div>

        {collectionExhibitInfoPage.side_SettingUnfold && (
          <>
            {[
              ...collectionExhibitInfoPage.side_RawProperties,
              ...collectionExhibitInfoPage.side_BaseProperties,
            ].length > 0 && (
              <>
                <div style={{ height: 5 }} />
                <div className={styles.block} style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <FComponentsLib.FContentText
                      // text={'基础属性'}
                      text={FI18n.i18nNext.t('edit_exhibit_resourceinfo')}
                      type={'highlight'}
                    />
                  </div>
                  <div style={{ height: 20 }} />
                  <FAttrsAndConfigs
                    dateSource={[
                      ...collectionExhibitInfoPage.side_RawProperties,
                      ...collectionExhibitInfoPage.side_BaseProperties,
                    ].map<IAttrsAndConfigsItem>((ba) => ({
                      key: ba.key,
                      name: ba.name,
                      description: ba.description,
                      value: ba.value,
                      configs: {
                        item_Deletable: false,
                        key_Editable: false,
                        name_Editable: false,
                        description_Editable: false,
                        value_Editable: false,
                      },
                    }))}
                    disabledKeys={[]}
                    disabledNames={[]}
                  />
                </div>
              </>
            )}

            {collectionExhibitInfoPage.inheritOptions.length > 0 && (
              <>
                <div style={{ height: 5 }} />
                <div className={styles.block} style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <FComponentsLib.FContentText
                      // text={'可选配置'}
                      text={FI18n.i18nNext.t('edit_exhibit_resourceoptions')}
                      type={'highlight'}
                    />
                  </div>

                  <div style={{ height: 10 }} />
                  <FAttrsAndConfigs
                    dateSource={collectionExhibitInfoPage.inheritOptions.map<IAttrsAndConfigsItem>(
                      (io) => ({
                        key: io.key,
                        name: io.name,
                        description: io.description,
                        value: io.value,
                        configs: {
                          item_Deletable: false,
                          key_Editable: false,
                          name_Editable: false,
                          description_Editable: false,
                          value_Editable:
                            io.type === 'select'
                              ? {
                                  configEnum: {
                                    nullable: false,
                                    defaultValue: io.defaultValue,
                                    options: io.options,
                                  },
                                }
                              : {
                                  configText: {
                                    nullable: false,
                                    defaultValue: io.defaultValue,
                                    minLength: 1,
                                    maxLength: 140,
                                  },
                                },
                        },
                      }),
                    )}
                    disabledKeys={[]}
                    disabledNames={[]}
                    onChangeItem={async (oldData, newData, index, changedFields) => {
                      const inheritOptions: CollectionExhibitInfoPageModelState['inheritOptions'] =
                        collectionExhibitInfoPage.inheritOptions.map((io, io_index) => {
                          if (io_index === index) {
                            return {
                              ...io,
                              key: newData.key,
                              name: newData.name,
                              description: newData.description,
                              value: newData.value,
                            };
                          }
                          return io;
                        });

                      await dispatch<ChangeAction>({
                        type: 'collectionExhibitInfoPage/change',
                        payload: {
                          inheritOptions: inheritOptions,
                        },
                      });

                      await dispatch<OnSync_Options_Action>({
                        type: 'collectionExhibitInfoPage/onSync_Options',
                        payload: {
                          successMessage: changedFields.includes('value')
                            ? FI18n.i18nNext.t('saved_successfully')
                            : undefined,
                        },
                      });
                    }}
                  />
                </div>
              </>
            )}

            <div style={{ height: 5 }} />
            <div className={styles.block} style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <FComponentsLib.FContentText
                  // text={'自定义信息'}
                  text={FI18n.i18nNext.t('edit_exhibit_customdata')}
                  type={'highlight'}
                />
                {collectionExhibitInfoPage.customOptions.length < 30 && (
                  <FComponentsLib.FTextBtn
                    style={{
                      fontSize: 12,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 5,
                    }}
                    type='primary'
                    onClick={async () => {
                      const dataSource: {
                        key: string;
                        name: string;
                        description: string;
                      } | null = await fResourcePropertyEditor3({
                        disabledKeys: [
                          ...collectionExhibitInfoPage.side_RawProperties.map((ba) => ba.key),
                          ...collectionExhibitInfoPage.side_BaseProperties.map((ba) => ba.key),
                          ...collectionExhibitInfoPage.inheritOptions.map((io) => io.key),
                          ...collectionExhibitInfoPage.customOptions.map((co) => co.key),
                        ],
                        disabledNames: [],
                      });

                      if (!dataSource) {
                        return;
                      }

                      await dispatch<ChangeAction>({
                        type: 'collectionExhibitInfoPage/change',
                        payload: {
                          customOptions: [
                            ...collectionExhibitInfoPage.customOptions,
                            { ...dataSource, value: '' },
                          ],
                        },
                      });

                      dispatch<OnSync_Options_Action>({
                        type: 'collectionExhibitInfoPage/onSync_Options',
                      });
                    }}
                  >
                    <FIcons.FConfiguration style={{ fontSize: 14 }} />
                    <span>
                      {
                        // 添加自定义信息
                        FI18n.i18nNext.tAuto('edit_exhibit_btn_addcustomdata')
                      }
                    </span>
                  </FComponentsLib.FTextBtn>
                )}
              </div>

              {collectionExhibitInfoPage.customOptions.length === 0 && (
                <>
                  <div style={{ height: 10 }} />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <FComponentsLib.FContentText
                      text={
                        // 自定义信息是资源在消费端展示时所需的配置信息，您可以根据需要添加。
                        FI18n.i18nNext.t('edit_exhibit_customdata_info')
                      }
                      type={'additional2'}
                    />
                  </div>
                  <div style={{ height: 20 }} />
                </>
              )}

              {collectionExhibitInfoPage.customOptions.length > 0 && (
                <>
                  <div style={{ height: 20 }} />

                  <FAttrsAndConfigs
                    dateSource={collectionExhibitInfoPage.customOptions.map((co) => ({
                      key: co.key,
                      name: co.name,
                      value: co.value,
                      description: co.description,
                      configs: {
                        item_Deletable: true,
                        key_Editable: true,
                        name_Editable: true,
                        description_Editable: true,
                        value_Editable: {
                          text: {
                            nullable: true,
                            minLength: 1,
                            maxLength: 140,
                          },
                        },
                      },
                    }))}
                    onChange={(dataSource, changedFields) => {
                      dispatch<ChangeAction>({
                        type: 'collectionExhibitInfoPage/change',
                        payload: {
                          customOptions: dataSource.map((co) => ({
                            key: co.key,
                            name: co.name,
                            value: co.value,
                            description: co.description,
                          })),
                        },
                      });
                      dispatch<OnSync_Options_Action>({
                        type: 'collectionExhibitInfoPage/onSync_Options',
                        payload: {
                          successMessage: changedFields.includes('value')
                            ? FI18n.i18nNext.t('saved_successfully')
                            : undefined,
                        },
                      });
                    }}
                    disabledKeys={[]}
                    disabledNames={[]}
                  />
                </>
              )}
            </div>
          </>
        )}

        <div style={{ height: 15 }} />

        <div className={styles.block}>
          <div ref={ref_ItemsTitle} />
          <FComponentsLib.FContentText
            text={
              // 单品管理
              FI18n.i18nNext.t('edit_exhibit_collection_itemmgnt')
            }
            type={'highlight'}
          />
          <div style={{ height: 20 }} />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <FComponentsLib.FContentText
              text={
                // 单品数量 100
                FI18n.i18nNext.t('edit_exhibit_collection_itemmgnt_count', {
                  itemCount: collectionExhibitInfoPage.collectionItems_totalCount,
                })
              }
              type={'additional2'}
              style={{ color: '#222' }}
            />
            {/* <FComponentsLib.FInput.FSearch */}
            <FInput_Search
              value={collectionExhibitInfoPage.collectionItems_keywords}
              onChange={(e) => {
                dispatch<ChangeAction>({
                  type: 'collectionExhibitInfoPage/change',
                  payload: {
                    collectionItems_keywords: e.target.value,
                  },
                });
                keywordsRun();
              }}
              placeholder={FI18n.i18nNext.t('cqr_itemmgmt_search_hint')}
            />
          </div>

          {!collectionExhibitInfoPage.collectionItems_inited && <FLoadingTip height={600} />}

          {collectionExhibitInfoPage.collectionItems_inited &&
            collectionExhibitInfoPage.collectionItems.length === 0 && (
              <FNoDataTip height={200} tipText={'暂无单品'} />
            )}
          {/*{*/}
          {/*  collectionExhibitInfoPage.collectionItems.length === 0 && collectionExhibitInfoPage.collectionItems_keywords !== '' && (*/}
          {/*    <FNoDataTip height={200} tipText={'无搜索结果'} />)*/}
          {/*}*/}
          {collectionExhibitInfoPage.collectionItems_inited &&
            collectionExhibitInfoPage.collectionItems.length > 0 && (
              <>
                <div style={{ height: 20 }} />
                <FCollectionItems2
                  // setting={collectionExhibitInfoPage.collectionItemsSetting}
                  showView={
                    collectionExhibitInfoPage.collectionItemsSetting.collection_view ===
                    'collection_view_list'
                      ? 'list'
                      : 'card'
                  }
                  showCover={
                    collectionExhibitInfoPage.collectionItemsSetting
                      .collection_item_image_display === 'collection_item_image_display_show'
                      ? 'show'
                      : 'hide'
                  }
                  showNumber={
                    collectionExhibitInfoPage.collectionItemsSetting.collection_item_no_display ===
                    'collection_item_no_display_show'
                      ? 'show'
                      : 'hide'
                  }
                  showTitle={
                    collectionExhibitInfoPage.collectionItemsSetting.collection_item_title ===
                    'collection_item_title_rtitle'
                      ? 'title'
                      : collectionExhibitInfoPage.collectionItemsSetting.collection_item_title ===
                        'collection_item_title_sn'
                      ? 'serial'
                      : collectionExhibitInfoPage.collectionItemsSetting.collection_item_title ===
                        'collection_item_title_custom'
                      ? 'customNotEdited'
                      : 'hide'
                  }
                  showIntroduction={
                    collectionExhibitInfoPage.collectionItemsSetting
                      .collection_item_descr_display === 'collection_item_descr_display_show'
                      ? 'show'
                      : 'hide'
                  }
                  resources={collectionExhibitInfoPage.collectionItems}
                />
              </>
            )}

          {((collectionExhibitInfoPage.collectionItemsSetting.collection_view ===
            'collection_view_list' &&
            collectionExhibitInfoPage.collectionItems_totalCount > 10) ||
            (collectionExhibitInfoPage.collectionItemsSetting.collection_view ===
              'collection_view_card' &&
              collectionExhibitInfoPage.collectionItems_totalCount > 6)) && (
            <>
              <div style={{ height: 20 }} />

              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Pagination
                  showTitle={false}
                  locale={{
                    items_per_page: '条/页',
                    jump_to: '前往',
                    page: '页',
                  }}
                  size='small'
                  showSizeChanger
                  showQuickJumper
                  current={collectionExhibitInfoPage.collectionItems_pageCurrent}
                  pageSize={collectionExhibitInfoPage.collectionItems_pageSize}
                  total={collectionExhibitInfoPage.collectionItems_totalCount}
                  onChange={async (page, pageSize) => {
                    const version_resources_pageCurrent =
                      collectionExhibitInfoPage.collectionItems_pageCurrent;
                    await dispatch<ChangeAction>({
                      type: 'collectionExhibitInfoPage/change',
                      payload: {
                        collectionItems_pageCurrent: page,
                        collectionItems_pageSize: pageSize,
                      },
                    });
                    await dispatch<Fetch_CollectionItems_Action>({
                      type: 'collectionExhibitInfoPage/fetch_CollectionItems',
                    });
                    if (page !== version_resources_pageCurrent) {
                      ref_ItemsTitle.current?.scrollIntoView({
                        behavior: 'smooth',
                        // block: 'end',
                        // inline: 'nearest',
                      });
                    }
                  }}
                  showTotal={(total) => {
                    return `共${total}条`;
                  }}
                  pageSizeOptions={
                    collectionExhibitInfoPage.collectionItemsSetting.collection_view ===
                    'collection_view_card'
                      ? [6, 12, 18, 24, 30]
                      : [10, 20, 30, 40, 50]
                  }
                />
              </div>
            </>
          )}
        </div>

        <div style={{ height: 5 }} />

        <Policies />

        <div style={{ height: 5 }} />
        <div className={styles.block}>
          {collectionExhibitInfoPage.exhibit_ResourceInfo &&
            collectionExhibitInfoPage.exhibit_BelongNode_ID !== -1 && (
              <FMicroAPP_Authorization
                licenseeId={collectionExhibitInfoPage.exhibit_BelongNode_ID}
                mainAppType={'resourceInExhibit'}
                depList={[
                  {
                    id: collectionExhibitInfoPage.exhibit_ResourceInfo.id,
                    name: collectionExhibitInfoPage.exhibit_ResourceInfo.name,
                    type: 'resource',
                    // versionRange?: string;
                  },
                ]}
                upcastList={[]}
                autoOpenPendingDrawer={!!urlState.openAuthDrawer}
                mount={() => {
                  // console.log('mount');
                }}
                update={(value) => {
                  // if (get$authorizationUpdate() > 0) {
                  dispatch<FetchInfoAction>({
                    type: 'collectionExhibitInfoPage/fetchInfo',
                  });
                  // }
                  set$authorizationUpdate(get$authorizationUpdate() + 1);
                }}
              />
            )}
        </div>

        {collectionExhibitInfoPage.graphShow && (
          <>
            <div style={{ height: 5 }} />
            <div className={styles.block}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <FComponentsLib.FContentText
                  // text={'相关视图'}
                  text={FI18n.i18nNext.t('edit_exhibit_maps')}
                  type={'highlight'}
                />
              </div>
              <div style={{ height: 10 }} />
              <Viewports />
            </div>
          </>
        )}

        <div style={{ height: 100 }} />
      </div>
      <FGlobalLoading
        open={$globalLoading}
        onOpened={(promise) => {
          refPromise.current = promise;
        }}
        onClosed={() => {}}
      />
    </div>
  );
}

export default connect(({ collectionExhibitInfoPage }: ConnectState) => ({
  collectionExhibitInfoPage,
}))(Presentable);
